import module from './index'
import moduleMain from './View'
import moduleCreate from './create/View'
import moduleList from './list/View'


let moduleName = 'module->' + module.info.name;

const routes = [
  {
    path: module.info.name,
    name: moduleName,
    component: moduleMain,
    children: [
      {
        path: 'create',
        name: moduleName + '->create',
        component: moduleCreate
      },
      {
        path: 'list',
        name: moduleName + '->list',
        component: moduleList
      }
    ]
  }
];

export default routes
